export class AuthBasedInit {
    private us;

    constructor(userService) {
        this.us = userService;
    }

    authBasedInit(callback) {
        const user = this.us.getUser()
        if (user != null) {
            callback(user);
            return;
        }
        this.us.onUserReady.subscribe(() => {
            callback();
        });
    }
}
